import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/ikyo.jpeg";
import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const productMarketingSchoolDataEurope = {
  tag: "Product Marketing",
  id: "productMarketingSchool",
  url: "/product-marketing-school",
  image: SchoolImage,

  name: "Product Marketing School",
  description: `The Utiva Product Marketing Program is designed for you. 
  Whether you’re new to the industry or a seasoned PMM, B2B or B2C, 
  physical or SaaS, by the end of this program, you’ll have all the 
  knowledge and tools needed to effectively and successfully attract and keep more customers.
  `,
  keywords: `product marketing,  sales, conversion`,
  metatags: `Become a product marketer in 3 month. Learn from the largest marketing school in Nigeria. Take the most practical product marketing training.`,

  courses: [],

  testimony: {
    testimonierImage: TestimonialImage,
    testimonierName: "Terhile Ikyo",
    testimonierTitle: "Product Marketing",
    testimonyDescription: `
    This course is everything a Product Marketer needs and it explores the 
    unique role of PMM in a way that has simply not been done before. Every lesson has actionable learnings 
    and sparks new ideas, making this PMM excited to roll up their sleeves and get to work.`,
  },

  article: [],

  careerTitle: "Product Marketer",

  careerPaths: [
    "Product Marketing Manager",
    "Product Leader",
    "VP of Marketing",
    "Product Marketing Specialist",
    "Chief Marketing Officer",
  ],

  quickFactSalary: "$116,000",

  quickFacts: [
    "Product Marketing has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum.",
  ],
};
